module.exports = __webpack_public_path__ + "62a5c9ef7e4ea02a21c0e7e52d1dacdd.svg";